<!-- addAccommodationFromImage.vue -->
<template>
  <BaseFromImage
    :dateTitle="t('addAccommodationPlaceTitle')"
    :addToRide="addToRide"
  />
</template>

<script>
import BaseFromImage from '@/components/BaseFromImage.vue';
import { mapActions } from 'vuex';
import { UPLOAD_RIDE_STATES } from '@/constants/uploadRideStates.js';
import { translationMixin } from '@/mixins/translationMixin';

export default {
  components: {
    BaseFromImage, // Register the component here
  },
  mixins: [translationMixin],
  methods: {
    ...mapActions([ 'addAccommodationToRideFromImage',
    ]),
    async addToRide(place) {
      await this.addAccommodationToRideFromImage(place);
    },
  },
  mounted() {
    this.$store.commit('setUploadRideState', UPLOAD_RIDE_STATES.ADDING_ACCOMMODATIONS_FROM_IMAGES);
  },
};
</script>